/** Not Defterim (Market app "notebook") texts; spread into `tr`. Keys start with nb. (and the app's Market keys). */
export const notebookTr = {
  'market.app.notebook.name': 'Not Defterim',
  'market.app.notebook.desc': 'Notlarını düzenle, belgelerini oluştur, özel bilgilerini güvenle sakla, DijitalApp kişilerinle paylaş ve aynı dokümanda birlikte çalış. Her şey tek yerde.',
  'market.permission.contacts': 'kişilerin (paylaşım için)',
  'market.permission.files': 'dosyalar (ekler ve içe aktarma)',
  'market.permission.notifications': 'bildirimler',
  'error.EDIT_CONFLICT': 'Bu kayıt sen açtıktan sonra değişti. Son halini yükleyip yeniden dene.',

  // navigation
  'nb.nav.home': 'Ana Sayfa',
  'nb.nav.quick': 'Hızlı Notlar',
  'nb.nav.all': 'Tüm Notlarım',
  'nb.nav.folders': 'Defterlerim',
  'nb.nav.docs': 'Belgelerim',
  'nb.nav.sheets': 'Tablolarım',
  'nb.nav.vault': 'Şifre Kasam',
  'nb.nav.shared': 'Benimle Paylaşılanlar',
  'nb.nav.workspaces': 'Ortak Çalışma Alanları',
  'nb.nav.favorites': 'Favoriler',
  'nb.nav.recent': 'Son Açılanlar',
  'nb.nav.archive': 'Arşiv',
  'nb.nav.trash': 'Çöp Kutusu',
  'nb.nav.activity': 'Etkinlik Geçmişi',
  'nb.nav.settings': 'Ayarlar',
  'nb.nav.tags': 'Etiketler',
  'nb.nav.invites': 'Davetler',
  'nb.nav.notifications': 'Bildirimler',
  'nb.nav.menu': 'Not Defterim menüsü',
  'nb.nav.back': 'Listeye dön',

  // kinds
  'nb.kind.quick': 'Hızlı Not',
  'nb.kind.doc': 'Zengin Metin Belgesi',
  'nb.kind.checklist': 'Kontrol Listesi',
  'nb.kind.table': 'Tablo',
  'nb.kind.sheet': 'Çalışma Sayfası',
  'nb.kind.meeting': 'Toplantı Notu',
  'nb.kind.journal': 'Günlük',
  'nb.kind.code': 'Kod Notu',
  'nb.kind.secure': 'Güvenli Not',
  'nb.kind.password': 'Şifre Kaydı',
  'nb.kind.template': 'Şablondan Oluştur',

  // list
  'nb.new': 'Yeni',
  'nb.newNote': 'Yeni not',
  'nb.newQuick': 'Hızlı not',
  'nb.search': 'Notlarda ara',
  'nb.searchHint': 'Başlık, içerik ya da etiket',
  'nb.filter': 'Filtre',
  'nb.filter.kind': 'Tür',
  'nb.filter.any': 'Hepsi',
  'nb.filter.shared': 'Paylaşım',
  'nb.filter.sharedMine': 'Paylaştıklarım',
  'nb.filter.sharedWithMe': 'Benimle paylaşılan',
  'nb.filter.private': 'Yalnız benim',
  'nb.filter.from': 'Başlangıç',
  'nb.filter.to': 'Bitiş',
  'nb.filter.clear': 'Filtreleri temizle',
  'nb.sort': 'Sırala',
  'nb.sort.updated': 'Son değişen',
  'nb.sort.created': 'Oluşturulma',
  'nb.sort.title': 'Başlık',
  'nb.sort.opened': 'Son açılan',
  'nb.layout.list': 'Liste',
  'nb.layout.grid': 'Kartlar',
  'nb.untitled': 'Başlıksız',
  'nb.empty.title': 'Burada henüz not yok',
  'nb.empty.body': 'İlk notunu oluştur; yazdıkça kendiliğinden kaydedilir.',
  'nb.empty.search': 'Aramana uyan not bulunamadı.',
  'nb.empty.trash': 'Çöp kutusu boş. Silinen notlar {days} gün burada kalır.',
  'nb.empty.shared': 'Seninle paylaşılan not yok. Biri paylaştığında burada görünür.',
  'nb.empty.pick': 'Soldan bir not seç ya da yeni bir not oluştur.',
  'nb.loadMore': 'Daha fazla',
  'nb.retry': 'Yeniden dene',
  'nb.loadError': 'Yüklenemedi. Bağlantını kontrol edip yeniden dene.',
  'nb.offline': 'Çevrimdışısın. Değişikliklerin bu cihazda saklanıyor, bağlantı gelince eşitlenecek.',
  'nb.pinned': 'Sabitlenen',
  'nb.sharedBadge': 'Paylaşılan',
  'nb.ownerLine': '{name} sahibi',
  'nb.words': { one: '{count} kelime', other: '{count} kelime' },
  'nb.chars': { one: '{count} karakter', other: '{count} karakter' },
  'nb.updatedAgo': 'Değişti: {when}',

  // home
  'nb.home.hello': 'Merhaba {name}',
  'nb.home.recent': 'Son açtıkların',
  'nb.home.pinned': 'Sabitlediklerin',
  'nb.home.quickPlaceholder': 'Aklındakini yaz, Enter ile kaydet…',
  'nb.home.create': 'Oluştur',
  'nb.home.stats': '{notes} not · {shared} paylaşılan',
  'nb.home.invites': { one: '{count} paylaşım daveti bekliyor', other: '{count} paylaşım daveti bekliyor' },

  // note actions
  'nb.action.favorite': 'Favorilere ekle',
  'nb.action.unfavorite': 'Favorilerden çıkar',
  'nb.action.pin': 'Sabitle',
  'nb.action.unpin': 'Sabitlemeyi kaldır',
  'nb.action.share': 'Paylaş',
  'nb.action.sendChat': 'Mesajla gönder',
  'nb.action.duplicate': 'Kopyasını oluştur',
  'nb.action.copySuffix': '{title} (kopya)',
  'nb.action.move': 'Taşı',
  'nb.action.moveRoot': 'Klasörsüz',
  'nb.action.archive': 'Arşivle',
  'nb.action.unarchive': 'Arşivden çıkar',
  'nb.action.trash': 'Çöp kutusuna taşı',
  'nb.action.restore': 'Geri yükle',
  'nb.action.deleteForever': 'Kalıcı olarak sil',
  'nb.action.deleteForeverConfirm': 'Bu not kalıcı olarak silinecek. Geri alınamaz. Emin misin?',
  'nb.action.export': 'Dışa aktar',
  'nb.action.import': 'İçe aktar',
  'nb.action.print': 'Yazdır / PDF',
  'nb.action.versions': 'Sürüm geçmişi',
  'nb.action.activity': 'Etkinlik',
  'nb.action.comments': 'Yorumlar',
  'nb.action.details': 'Ayrıntılar',
  'nb.action.saveTemplate': 'Şablon olarak kaydet',
  'nb.action.templateName': 'Şablon adı',
  'nb.action.reminder': 'Hatırlatma',
  'nb.action.reminderClear': 'Hatırlatmayı kaldır',
  'nb.action.color': 'Renk',
  'nb.action.icon': 'Simge',
  'nb.action.cover': 'Kapak',
  'nb.action.tags': 'Etiketler',
  'nb.action.tagsHint': 'Virgülle ayır',
  'nb.action.description': 'Açıklama',
  'nb.action.fullscreen': 'Tam ekran',
  'nb.action.focus': 'Odak modu',
  'nb.action.exitFocus': 'Odaktan çık',
  'nb.action.more': 'Diğer işlemler',
  'nb.action.close': 'Kapat',
  'nb.done': 'Tamam',
  'nb.cancel': 'Vazgeç',
  'nb.save': 'Kaydet',
  'nb.delete': 'Sil',
  'nb.rename': 'Yeniden adlandır',
  'nb.titlePlaceholder': 'Başlık',

  // save state
  'nb.save.saved': 'Kaydedildi',
  'nb.save.saving': 'Kaydediliyor…',
  'nb.save.syncing': 'Eşitleniyor…',
  'nb.save.offline': 'Çevrimdışı · bu cihazda',
  'nb.save.error': 'Kaydedilemedi, yeniden deneniyor',
  'nb.save.readonly': 'Salt okunur',
  'nb.conflict': 'Bu not başka bir yerde değişti; son hali yüklendi.',
  'nb.accessLost': 'Bu nota erişimin kaldırıldı.',
  'nb.deletedElsewhere': 'Bu not silindi.',

  // folders
  'nb.folder.new': 'Yeni klasör',
  'nb.folder.newSub': 'Alt klasör',
  'nb.folder.name': 'Klasör adı',
  'nb.folder.delete': 'Klasörü sil',
  'nb.folder.deleteConfirm': '"{name}" ve alt klasörleri silinecek; içindeki notlar çöp kutusuna taşınır. Emin misin?',
  'nb.folder.dropHere': 'Buraya bırak',
  'nb.folder.none': 'Henüz klasör yok',

  // editor
  'nb.ed.bold': 'Kalın',
  'nb.ed.italic': 'İtalik',
  'nb.ed.underline': 'Altı çizili',
  'nb.ed.strike': 'Üstü çizili',
  'nb.ed.sub': 'Alt simge',
  'nb.ed.sup': 'Üst simge',
  'nb.ed.code': 'Satır içi kod',
  'nb.ed.color': 'Metin rengi',
  'nb.ed.highlight': 'Arka plan rengi',
  'nb.ed.clearColor': 'Rengi kaldır',
  'nb.ed.font': 'Yazı tipi',
  'nb.ed.size': 'Yazı boyutu',
  'nb.ed.lineHeight': 'Satır aralığı',
  'nb.ed.alignLeft': 'Sola hizala',
  'nb.ed.alignCenter': 'Ortala',
  'nb.ed.alignRight': 'Sağa hizala',
  'nb.ed.alignJustify': 'İki yana yasla',
  'nb.ed.paragraph': 'Paragraf',
  'nb.ed.h1': 'Başlık 1',
  'nb.ed.h2': 'Başlık 2',
  'nb.ed.h3': 'Başlık 3',
  'nb.ed.bullet': 'Madde işaretli liste',
  'nb.ed.ordered': 'Numaralı liste',
  'nb.ed.task': 'Kontrol listesi',
  'nb.ed.indent': 'Girintiyi artır',
  'nb.ed.outdent': 'Girintiyi azalt',
  'nb.ed.quote': 'Alıntı',
  'nb.ed.callout': 'Bilgi kutusu',
  'nb.ed.divider': 'Ayırıcı',
  'nb.ed.link': 'Bağlantı',
  'nb.ed.linkPrompt': 'Bağlantı adresi (https://…)',
  'nb.ed.unlink': 'Bağlantıyı kaldır',
  'nb.ed.image': 'Görsel',
  'nb.ed.file': 'Dosya ekle',
  'nb.ed.table': 'Tablo',
  'nb.ed.tableAddRow': 'Satır ekle',
  'nb.ed.tableAddCol': 'Sütun ekle',
  'nb.ed.tableDelRow': 'Satırı sil',
  'nb.ed.tableDelCol': 'Sütunu sil',
  'nb.ed.tableMerge': 'Hücreleri birleştir / ayır',
  'nb.ed.tableHeader': 'Başlık satırı',
  'nb.ed.tableDelete': 'Tabloyu sil',
  'nb.ed.codeBlock': 'Kod bloğu',
  'nb.ed.emoji': 'Emoji',
  'nb.ed.date': 'Tarih ve saat',
  'nb.ed.toc': 'İçindekiler',
  'nb.ed.tocEmpty': 'Başlık ekledikçe içindekiler burada oluşur.',
  'nb.ed.noteLink': 'Nota bağlantı',
  'nb.ed.noteLinkPrompt': 'Bağlanacak notu ara',
  'nb.ed.mention': 'Kişiyi etiketle',
  'nb.ed.undo': 'Geri al',
  'nb.ed.redo': 'Yinele',
  'nb.ed.placeholder': 'Yazmaya başla ya da komutlar için "/" yaz…',
  'nb.ed.slashEmpty': 'Komut bulunamadı',
  'nb.ed.toolbar': 'Biçimlendirme araçları',
  'nb.ed.mobileTools': 'Düzenleme araçları',
  'nb.ed.uploading': 'Yükleniyor…',
  'nb.ed.uploadFailed': 'Dosya yüklenemedi.',
  'nb.ed.calloutText': 'Önemli bir not…',

  // paste
  'nb.paste.title': 'Yapıştırma seçenekleri',
  'nb.paste.source': 'Kaynak: {source}',
  'nb.paste.keep': 'Kaynak biçimini koru',
  'nb.paste.adapt': 'Not Defterim stiline uyarla',
  'nb.paste.plain': 'Yalnız metin',
  'nb.paste.table': 'Tablo olarak',
  'nb.paste.lossy': 'Bazı biçimler aktarılamadı: {what}.',
  'nb.paste.cleaned': 'Güvenlik için betikler ve izin verilmeyen içerik temizlendi.',
  'nb.paste.src.word': 'Microsoft Word',
  'nb.paste.src.excel': 'Microsoft Excel',
  'nb.paste.src.gdocs': 'Google Dokümanlar',
  'nb.paste.src.gsheets': 'Google E-Tablolar',
  'nb.paste.src.web': 'Web sayfası',
  'nb.paste.src.text': 'Düz metin',
  'nb.paste.lost.objects': 'gömülü nesneler',
  'nb.paste.lost.nestedMerge': 'iç içe birleşik hücreler',
  'nb.paste.lost.shapes': 'şekiller ve çizimler',
  'nb.paste.lost.comments': 'Word yorumları',

  // import / export
  'nb.import.title': 'Dosyadan içe aktar',
  'nb.import.hint': '.docx, .xlsx, .csv, .md ve .txt dosyaları (en çok {mb} MB).',
  'nb.import.choose': 'Dosya seç',
  'nb.import.busy': 'İçe aktarılıyor…',
  'nb.import.unsupported': 'Bu dosya türü desteklenmiyor.',
  'nb.import.tooBig': 'Dosya {mb} MB sınırını aşıyor.',
  'nb.import.failed': 'Dosya okunamadı. Bozuk ya da parolalı olabilir.',
  'nb.import.done': '"{name}" içe aktarıldı.',
  'nb.export.html': 'HTML',
  'nb.export.md': 'Markdown',
  'nb.export.txt': 'Düz metin',
  'nb.export.csv': 'CSV',
  'nb.export.xlsx': 'Excel (.xlsx)',
  'nb.export.notAllowed': 'Bu notu dışa aktarma iznin yok.',

  // sheet
  'nb.sheet.addRow': 'Satır ekle',
  'nb.sheet.addCol': 'Sütun ekle',
  'nb.sheet.insertRowAbove': 'Üste satır ekle',
  'nb.sheet.insertColLeft': 'Sola sütun ekle',
  'nb.sheet.delRow': 'Satırı sil',
  'nb.sheet.delCol': 'Sütunu sil',
  'nb.sheet.merge': 'Birleştir',
  'nb.sheet.unmerge': 'Birleştirmeyi kaldır',
  'nb.sheet.sortAsc': 'A → Z sırala',
  'nb.sheet.sortDesc': 'Z → A sırala',
  'nb.sheet.filter': 'Filtrele',
  'nb.sheet.filterPlaceholder': 'Bu sütunda içeren…',
  'nb.sheet.clearFilter': 'Filtreyi kaldır',
  'nb.sheet.freeze': 'Sabitle (satır/sütun)',
  'nb.sheet.unfreeze': 'Sabitlemeyi kaldır',
  'nb.sheet.format': 'Hücre biçimi',
  'nb.sheet.fmt.general': 'Genel',
  'nb.sheet.fmt.number': 'Sayı',
  'nb.sheet.fmt.percent': 'Yüzde',
  'nb.sheet.fmt.currency': 'Para (₺)',
  'nb.sheet.fmt.date': 'Tarih',
  'nb.sheet.fmt.datetime': 'Tarih ve saat',
  'nb.sheet.fmt.text': 'Metin',
  'nb.sheet.wrap': 'Metni kaydır',
  'nb.sheet.border': 'Kenarlık',
  'nb.sheet.find': 'Tabloda bul',
  'nb.sheet.formulaBar': 'Formül çubuğu',
  'nb.sheet.cell': 'Hücre {ref}',
  'nb.sheet.limit': 'Tablo sınırına ulaşıldı ({rows} satır × {cols} sütun).',
  'nb.sheet.sum': 'Toplam: {sum}',
  'nb.sheet.count': 'Sayı: {count}',
  'nb.sheet.avg': 'Ortalama: {avg}',
  'nb.sheet.formulaHelp': 'Formüller "=" ile başlar: =TOPLA(A1:A9), =ORTALAMA(B2:B5), =EĞER(C1>10;"Evet";"Hayır"). Ağ erişimi ve makro yoktur.',

  // sharing
  'nb.share.title': '"{title}" paylaş',
  'nb.share.search': 'Kişilerinde ara',
  'nb.share.noContacts': 'Kişi listen boş. Önce DijitalApp kişilerine birini ekle.',
  'nb.share.role': 'Rol',
  'nb.role.owner': 'Sahip',
  'nb.role.admin': 'Yönetici',
  'nb.role.editor': 'Düzenleyici',
  'nb.role.commenter': 'Yorumcu',
  'nb.role.viewer': 'Görüntüleyici',
  'nb.role.admin.hint': 'Düzenler ve paylaşımı yönetir',
  'nb.role.editor.hint': 'Düzenler ve yorum yapar',
  'nb.role.commenter.hint': 'Okur ve yorum yapar',
  'nb.role.viewer.hint': 'Yalnız okur',
  'nb.share.download': 'Ekleri indirebilir',
  'nb.share.export': 'Dışa aktarabilir',
  'nb.share.copy': 'Kopyalayabilir',
  'nb.share.reshare': 'Başkalarıyla paylaşabilir',
  'nb.share.expires': 'Erişim bitişi',
  'nb.share.never': 'Süresiz',
  'nb.share.message': 'Mesaj (isteğe bağlı)',
  'nb.share.send': 'Davet gönder',
  'nb.share.sent': { one: '{count} kişiye davet gönderildi.', other: '{count} kişiye davet gönderildi.' },
  'nb.share.people': 'Erişimi olanlar',
  'nb.share.pending': 'Davet bekliyor',
  'nb.share.declined': 'Reddetti',
  'nb.share.remove': 'Erişimi kaldır',
  'nb.share.removeConfirm': '{name} bu nota artık erişemeyecek. Açık olan kopyası hemen kapanır.',
  'nb.share.summary': 'Kişi listende olmak tek başına erişim vermez; yalnız davet ettiğin ve kabul eden kişiler görür.',
  'nb.share.copyNote': 'Kopyalama ve dışa aktarma kısıtları uygulamada uygulanır; ekran görüntüsünü engelleyemez.',
  'nb.share.public': 'Genel bağlantı',
  'nb.share.publicHint': 'Bağlantıya sahip herkes bu notu salt okunur görebilir. Hassas bilgi içeren notlarda açma.',
  'nb.share.publicConfirm': 'Bu notun bağlantıya sahip herkes tarafından görülebileceğini anlıyorum.',
  'nb.share.publicOn': 'Genel bağlantıyı aç',
  'nb.share.publicOff': 'Genel bağlantıyı kapat',
  'nb.share.publicCopy': 'Bağlantıyı kopyala',
  'nb.share.publicDisabled': 'Genel bağlantılar şu an kapalı.',
  'nb.share.copied': 'Kopyalandı',
  'nb.share.workspace': 'Çalışma alanı',
  'nb.share.workspaceHint': 'Seçilen çalışma alanının üyeleri rollerine göre erişir.',
  'nb.share.noWorkspace': 'Çalışma alanında değil',
  'nb.share.cannot': 'Bu notu paylaşma iznin yok.',
  'nb.visibility.private': 'Özel',
  'nb.visibility.shared': 'Paylaşılan',
  'nb.visibility.workspace': 'Çalışma Alanı',
  'nb.visibility.public': 'Genel',

  // invites
  'nb.invite.from': '{name} seninle paylaştı · {role}',
  'nb.invite.accept': 'Kabul et',
  'nb.invite.decline': 'Reddet',
  'nb.invite.none': 'Bekleyen davet yok.',

  // collaboration
  'nb.collab.online': { one: '{count} kişi burada', other: '{count} kişi burada' },
  'nb.collab.you': 'Sen',
  'nb.collab.reconnecting': 'Yeniden bağlanılıyor…',

  // comments
  'nb.comment.title': 'Yorumlar',
  'nb.comment.add': 'Yorum ekle',
  'nb.comment.placeholder': 'Yorumunu yaz… @ ile birini etiketle',
  'nb.comment.reply': 'Yanıtla',
  'nb.comment.resolve': 'Çözüldü',
  'nb.comment.reopen': 'Yeniden aç',
  'nb.comment.resolved': 'Çözülenler',
  'nb.comment.empty': 'Henüz yorum yok. Metinden bir bölüm seçip yorum ekleyebilirsin.',
  'nb.comment.edited': 'düzenlendi',
  'nb.comment.disabled': 'Yorumlar kapalı.',
  'nb.comment.quote': 'Seçili metin: “{quote}”',

  // versions
  'nb.ver.title': 'Sürüm geçmişi',
  'nb.ver.saveNow': 'Bu hali sürüm olarak kaydet',
  'nb.ver.label': 'Sürüm adı (isteğe bağlı)',
  'nb.ver.kind.auto': 'Otomatik',
  'nb.ver.kind.manual': 'Elle kaydedildi',
  'nb.ver.kind.restore': 'Geri yüklemeden önce',
  'nb.ver.kind.import': 'İçe aktarma',
  'nb.ver.by': '{name} · {when}',
  'nb.ver.view': 'Görüntüle',
  'nb.ver.compare': 'Şimdiki halle karşılaştır',
  'nb.ver.restore': 'Bu sürüme dön',
  'nb.ver.restoreConfirm': 'Not bu sürümdeki haline döner. Şimdiki hali önce bir sürüm olarak kaydedilir.',
  'nb.ver.restored': 'Sürüm geri yüklendi.',
  'nb.ver.empty': 'Henüz sürüm yok. Sen yazdıkça otomatik sürümler oluşur.',
  'nb.ver.added': 'Eklenen',
  'nb.ver.removed': 'Silinen',
  'nb.ver.same': 'Bu sürüm şimdiki halle aynı.',

  // activity
  'nb.act.title': 'Etkinlik',
  'nb.act.empty': 'Henüz etkinlik yok.',
  'nb.act.exportCsv': 'CSV indir',
  'nb.act.filterAll': 'Tüm etkinlikler',
  'nb.act.note': '“Açtı” yalnız notun açıldığını söyler; okunduğunu iddia etmez.',
  'nb.act.created': '{name} oluşturdu',
  'nb.act.opened': '{name} açtı',
  'nb.act.edited': '{name} düzenledi',
  'nb.act.renamed': '{name} başlığı değiştirdi',
  'nb.act.moved': '{name} taşıdı',
  'nb.act.commented': '{name} yorum yaptı',
  'nb.act.comment_resolved': '{name} bir yorumu çözdü',
  'nb.act.file_added': '{name} dosya ekledi',
  'nb.act.file_removed': '{name} bir dosyayı kaldırdı',
  'nb.act.invite_sent': '{name} davet gönderdi',
  'nb.act.invite_accepted': '{name} daveti kabul etti',
  'nb.act.invite_declined': '{name} daveti reddetti',
  'nb.act.permission_changed': '{name} bir izni değiştirdi',
  'nb.act.permission_removed': '{name} bir erişimi kaldırdı',
  'nb.act.public_on': '{name} genel bağlantıyı açtı',
  'nb.act.public_off': '{name} genel bağlantıyı kapattı',
  'nb.act.archived': '{name} arşivledi',
  'nb.act.unarchived': '{name} arşivden çıkardı',
  'nb.act.trashed': '{name} çöp kutusuna taşıdı',
  'nb.act.restored': '{name} geri yükledi',
  'nb.act.version_saved': '{name} sürüm kaydetti',
  'nb.act.version_restored': '{name} bir sürümü geri yükledi',
  'nb.act.exported': '{name} dışa aktardı',
  'nb.act.access_denied': '{name} yetkisiz erişim denedi (engellendi)',
  'nb.act.someone': 'Biri',

  // notifications
  'nb.notif.title': 'Bildirimler',
  'nb.notif.empty': 'Bildirim yok.',
  'nb.notif.markRead': 'Tümünü okundu say',
  'nb.notif.shared': '{name} bir notu seninle paylaştı',
  'nb.notif.comment': '{name} yorum yaptı',
  'nb.notif.mention': '{name} seni etiketledi',
  'nb.notif.invite_accepted': '{name} davetini kabul etti',
  'nb.notif.access_request': '{name} erişim istedi',
  'nb.notif.changed': '{name} notunu düzenledi',
  'nb.notif.reminder': 'Hatırlatma',
  'nb.notif.vault_shared': '{name} seninle kasa kaydı paylaştı',
  'nb.push.shared': '{name} bir notu seninle paylaştı',
  'nb.push.sharedTitled': '{name} "{title}" notunu seninle paylaştı',
  'nb.push.comment': '{name} bir notta yorum yaptı',
  'nb.push.commentTitled': '{name} "{title}" notunda yorum yaptı',
  'nb.push.mention': '{name} seni bir notta etiketledi',
  'nb.push.mentionTitled': '{name} seni "{title}" notunda etiketledi',
  'nb.push.accepted': '{name} paylaşım davetini kabul etti',
  'nb.push.acceptedTitled': '{name} "{title}" davetini kabul etti',
  'nb.push.reminder': 'Bir notun için hatırlatma zamanı',
  'nb.push.reminderTitled': 'Hatırlatma: {title}',
  'nb.push.vaultShared': '{name} Şifre Kasam’da seninle bir kayıt paylaştı',

  // workspaces
  'nb.ws.new': 'Yeni çalışma alanı',
  'nb.ws.name': 'Çalışma alanı adı',
  'nb.ws.members': 'Üyeler',
  'nb.ws.addMember': 'Üye ekle',
  'nb.ws.leave': 'Ayrıl',
  'nb.ws.delete': 'Çalışma alanını sil',
  'nb.ws.deleteConfirm': 'Çalışma alanı silinir; notlar sahiplerinde özel olarak kalır.',
  'nb.ws.empty': 'Henüz çalışma alanın yok. Ekibinle ortak notlar için bir tane oluştur.',
  'nb.ws.disabled': 'Çalışma alanları şu an kapalı.',

  // settings
  'nb.set.title': 'Ayarlar',
  'nb.set.editor': 'Editör',
  'nb.set.font': 'Yazı tipi',
  'nb.set.font.sans': 'Sade',
  'nb.set.font.serif': 'Tırnaklı',
  'nb.set.font.mono': 'Eş aralıklı',
  'nb.set.width': 'Sayfa genişliği',
  'nb.set.width.normal': 'Normal',
  'nb.set.width.wide': 'Geniş',
  'nb.set.width.full': 'Tam',
  'nb.set.spellcheck': 'Yazım denetimi',
  'nb.set.defaultKind': 'Yeni notun türü',
  'nb.set.data': 'Verilerin',
  'nb.set.dataHint': 'Not Defterim’i Market’ten kaldırmak verilerini silmez; yeniden eklediğinde her şey yerinde olur.',
  'nb.set.export': 'Tüm verilerimi dışa aktar (JSON)',
  'nb.set.erase': 'Tüm Not Defterim verilerimi sil',
  'nb.set.eraseHint': 'Sahibi olduğun notlar, klasörler, çalışma alanları ve kasa kalıcı olarak silinir. Başkalarının seninle paylaştığı notlar onlarda kalır.',
  'nb.set.eraseConfirm': 'Onaylamak için kullanıcı adını yaz: {username}',
  'nb.set.erased': 'Not Defterim verilerin silindi.',
  'nb.set.templates': 'Şablonlarım',
  'nb.set.noTemplates': 'Kayıtlı şablonun yok. Bir notu “Şablon olarak kaydet” ile ekleyebilirsin.',
  'nb.set.privacy': 'Gizlilik',
  'nb.set.privacyHint': 'Normal notlar sunucuda şifreli bağlantıyla saklanır, uçtan uca şifreli değildir. Uçtan uca şifreleme yalnız Şifre Kasam’dadır.',

  // templates
  'nb.tpl.title': 'Şablondan oluştur',
  'nb.tpl.meeting': 'Toplantı notu',
  'nb.tpl.journal': 'Günlük sayfası',
  'nb.tpl.todo': 'Yapılacaklar',
  'nb.tpl.project': 'Proje planı',
  'nb.tpl.weekly': 'Haftalık plan',
  'nb.tpl.budget': 'Bütçe tablosu',
  'nb.tpl.code': 'Kod notu',
  'nb.tpl.lecture': 'Ders notu',
  'nb.tpl.mine': 'Şablonlarım',
  'nb.tpl.c.agenda': 'Gündem',
  'nb.tpl.c.attendees': 'Katılımcılar',
  'nb.tpl.c.decisions': 'Kararlar',
  'nb.tpl.c.actions': 'Yapılacaklar',
  'nb.tpl.c.goals': 'Hedefler',
  'nb.tpl.c.milestones': 'Aşamalar',
  'nb.tpl.c.risks': 'Riskler',
  'nb.tpl.c.grateful': 'Bugün minnettar olduklarım',
  'nb.tpl.c.today': 'Bugün neler oldu?',
  'nb.tpl.c.tomorrow': 'Yarın için',
  'nb.tpl.c.monday': 'Pazartesi',
  'nb.tpl.c.summary': 'Özet',
  'nb.tpl.c.keyPoints': 'Önemli noktalar',
  'nb.tpl.c.questions': 'Sorular',
  'nb.tpl.c.item': 'Kalem',
  'nb.tpl.c.planned': 'Planlanan',
  'nb.tpl.c.actual': 'Gerçekleşen',
  'nb.tpl.c.total': 'Toplam',
  'nb.tpl.c.snippet': 'Kod parçası',
  'nb.tpl.c.notes': 'Notlar',

  // vault
  'nb.v.title': 'Şifre Kasam',
  'nb.v.e2ee': 'Uçtan uca şifreli: kayıtların bu cihazda şifrelenir; sunucu ve DijitalApp çalışanları açamaz.',
  'nb.v.disabled': 'Şifre Kasam henüz açılmadı.',
  'nb.v.setupTitle': 'Kasanı oluştur',
  'nb.v.setupIntro': 'Kasa parolası, DijitalApp giriş parolandan ayrıdır ve sunucuya gönderilmez. Unutursan yalnız kurtarma anahtarınla açabilirsin.',
  'nb.v.passphrase': 'Kasa parolası',
  'nb.v.passphrase2': 'Kasa parolası (tekrar)',
  'nb.v.passTooShort': 'Kasa parolası en az {min} karakter olmalı.',
  'nb.v.passMismatch': 'Parolalar aynı değil.',
  'nb.v.passSameAsLogin': 'Giriş parolandan farklı bir parola seç.',
  'nb.v.create': 'Kasayı oluştur',
  'nb.v.creating': 'Anahtarlar oluşturuluyor…',
  'nb.v.recoveryTitle': 'Kurtarma anahtarın',
  'nb.v.recoveryIntro': 'Bunu güvenli bir yere yaz ya da yazdır. Yalnız bir kez gösterilir. Kasa parolanı ve bu anahtarı birlikte kaybedersen kasan kurtarılamaz.',
  'nb.v.recoverySaved': 'Kaydettim, devam et',
  'nb.v.recoveryCopy': 'Kopyala',
  'nb.v.unlockTitle': 'Kasa kilitli',
  'nb.v.unlock': 'Kilidi aç',
  'nb.v.unlocking': 'Açılıyor…',
  'nb.v.wrongPass': 'Kasa parolası yanlış.',
  'nb.v.useRecovery': 'Parolamı unuttum: kurtarma anahtarıyla aç',
  'nb.v.recoveryKey': 'Kurtarma anahtarı',
  'nb.v.wrongRecovery': 'Kurtarma anahtarı yanlış.',
  'nb.v.newPassAfterRecovery': 'Yeni bir kasa parolası belirle',
  'nb.v.lock': 'Kilitle',
  'nb.v.autoLock': '{min} dk hareketsizlikte kilitlenir',
  'nb.v.newItem': 'Yeni kayıt',
  'nb.v.search': 'Kasada ara',
  'nb.v.empty': 'Kasan boş. İlk şifre kaydını ekle.',
  'nb.v.mine': 'Kişisel kasam',
  'nb.v.sharedWithMe': 'Benimle paylaşılan kayıtlar',
  'nb.v.trash': 'Kasa çöp kutusu',
  'nb.v.events': 'Erişim kayıtları',
  'nb.v.kind.login': 'Giriş bilgisi',
  'nb.v.kind.secure_note': 'Güvenli not',
  'nb.v.kind.card': 'Kart',
  'nb.v.kind.identity': 'Kimlik',
  'nb.v.kind.wifi': 'Wi-Fi',
  'nb.v.kind.other': 'Diğer',
  'nb.v.f.name': 'Kayıt adı',
  'nb.v.f.site': 'Site / uygulama',
  'nb.v.f.url': 'Adres (URL)',
  'nb.v.f.username': 'Kullanıcı adı',
  'nb.v.f.email': 'E-posta',
  'nb.v.f.password': 'Şifre',
  'nb.v.f.notes': 'Açıklama',
  'nb.v.f.tags': 'Etiketler',
  'nb.v.f.category': 'Kategori',
  'nb.v.f.custom': 'Özel alan',
  'nb.v.f.customName': 'Alan adı',
  'nb.v.f.customValue': 'Değer',
  'nb.v.f.secret': 'Gizli',
  'nb.v.f.addCustom': 'Alan ekle',
  'nb.v.f.reminder': 'Değiştirme hatırlatması',
  'nb.v.f.updated': 'Güncellendi',
  'nb.v.show': 'Göster',
  'nb.v.hide': 'Gizle',
  'nb.v.copyUser': 'Kullanıcı adını kopyala',
  'nb.v.copyPass': 'Şifreyi kopyala',
  'nb.v.copied': 'Kopyalandı · {sec} sn sonra panodan silinmeye çalışılacak',
  'nb.v.noAccess': 'Bu alanı görme iznin yok',
  'nb.v.gen.title': 'Şifre üret',
  'nb.v.gen.length': 'Uzunluk: {n}',
  'nb.v.gen.upper': 'Büyük harf',
  'nb.v.gen.lower': 'Küçük harf',
  'nb.v.gen.digits': 'Rakam',
  'nb.v.gen.symbols': 'Simge',
  'nb.v.gen.ambiguous': 'Karışan karakterleri çıkar (0/O, 1/l)',
  'nb.v.gen.use': 'Bu şifreyi kullan',
  'nb.v.gen.again': 'Yeniden üret',
  'nb.v.strength.weak': 'Zayıf',
  'nb.v.strength.fair': 'Orta',
  'nb.v.strength.good': 'İyi',
  'nb.v.strength.strong': 'Güçlü',
  'nb.v.changeDue': 'Değiştirme zamanı geldi',
  'nb.v.rotateNeeded': 'Paylaşım kaldırıldı: anahtarlar yenileniyor…',
  'nb.v.changeSuggest': '{name} bu şifreyi daha önce gördü. Güvenliğin için şifreyi değiştirmeni öneririz; görülen bir şifre karşı cihazdan silinemez.',
  'nb.v.share': 'Seçilenleri paylaş',
  'nb.v.selected': { one: '{count} kayıt seçildi', other: '{count} kayıt seçildi' },
  'nb.v.selectAll': 'Tümünü seç',
  'nb.v.shareTitle': 'Kasa kayıtlarını paylaş',
  'nb.v.shareIntro': 'Alıcı yalnız seçtiğin kayıtları ve izin verdiğin alanları görür; kasanın geri kalanını göremez. Kayıtların anahtarları alıcının açık anahtarına bu cihazda şifrelenir.',
  'nb.v.shareTo': 'Kime',
  'nb.v.sharePick': 'Kişi seç',
  'nb.v.perm.meta': 'Kaydı görebilir (ad, site, kullanıcı adı)',
  'nb.v.perm.reveal': 'Gizli değeri açabilir',
  'nb.v.perm.edit': 'Gizli değeri düzenleyebilir',
  'nb.v.perm.manage': 'Kaydı yönetebilir',
  'nb.v.perm.manageSharing': 'Paylaşımı yönetebilir',
  'nb.v.fingerprint': 'Alıcının anahtar parmak izi: {fp}',
  'nb.v.fingerprintChanged': 'Dikkat: bu kişinin kasa anahtarı daha önce gördüğünden farklı. Kişiyle başka bir yoldan doğrulamadan paylaşma.',
  'nb.v.fingerprintHint': 'Emin olmak için bu kodu kişiyle başka bir yoldan (yüz yüze, telefon) karşılaştır.',
  'nb.v.noKeys': 'Bu kişi henüz Şifre Kasam’ı kurmamış.',
  'nb.v.shared': 'Paylaşıldı.',
  'nb.v.sharingOff': 'Kasa paylaşımı henüz açılmadı.',
  'nb.v.access': 'Erişimi olanlar',
  'nb.v.revoke': 'Erişimi kaldır',
  'nb.v.revoked': 'Erişim kaldırıldı.',
  'nb.v.never': 'Kasa hiçbir zaman genel bağlantıyla paylaşılmaz.',
  'nb.v.deleteConfirm': 'Bu kayıt kasa çöp kutusuna taşınacak.',
  'nb.v.purgeConfirm': 'Kayıt kalıcı olarak silinecek. Geri alınamaz.',
  'nb.v.reauth': 'Devam etmek için kasa parolanı yeniden gir',
  'nb.v.exportEnc': 'Şifreli yedek indir',
  'nb.v.exportCsv': 'CSV olarak dışa aktar (şifresiz)',
  'nb.v.exportCsvWarn': 'CSV dosyası şifreleri düz metin içerir. Yalnız güvendiğin bir cihaza kaydet ve işin bitince sil.',
  'nb.v.import': 'CSV içe aktar (Chrome, Bitwarden, 1Password)',
  'nb.v.imported': { one: '{count} kayıt içe aktarıldı', other: '{count} kayıt içe aktarıldı' },
  'nb.v.changePass': 'Kasa parolasını değiştir',
  'nb.v.newRecovery': 'Yeni kurtarma anahtarı oluştur',
  'nb.v.passChanged': 'Kasa parolası değiştirildi.',
  'nb.v.ev.created': 'oluşturdu',
  'nb.v.ev.updated': 'güncelledi',
  'nb.v.ev.reveal': 'gizli değeri açtı',
  'nb.v.ev.copy_username': 'kullanıcı adını kopyaladı',
  'nb.v.ev.copy_password': 'şifreyi kopyaladı',
  'nb.v.ev.copy_secret': 'gizli alanı kopyaladı',
  'nb.v.ev.shared': 'paylaştı',
  'nb.v.ev.share_revoked': 'erişimi kaldırdı',
  'nb.v.ev.keys_rotated': 'anahtarları yeniledi',
  'nb.v.ev.access_denied': 'yetkisiz erişim denedi (engellendi)',
  'nb.v.ev.unlock': 'kasayı açtı',
  'nb.v.ev.export': 'dışa aktardı',
  'nb.v.ev.import': 'içe aktardı',
  'nb.v.ev.trashed': 'çöp kutusuna taşıdı',
  'nb.v.ev.restored': 'geri yükledi',
  'nb.v.ev.purged': 'kalıcı sildi',
  'nb.v.ev.vault_created': 'kasayı oluşturdu',
  'nb.v.ev.passphrase_changed': 'kasa parolasını değiştirdi',
  'nb.v.ev.recovery_changed': 'kurtarma anahtarını yeniledi',
  'nb.v.ev.vault_reset': 'kasayı sıfırladı',
  'nb.v.ev.lock_failed': 'yanlış parola denedi',
  'nb.v.ev.empty': 'Kayıt yok.',

  // admin
  'nb.admin.button': 'Ayarlar',
  'nb.admin.title': 'Not Defterim ayarları',
  'nb.admin.intro': 'Alt modüller, sınırlar ve varsayılanlar. Şifre Kasam ve kasa paylaşımı Yapılandırma › Bayraklar’daki notebook_vault ve notebook_vault_sharing ile açılır (güvenlik testleri bitmeden açmayın).',
  'nb.admin.modules': 'Alt modüller',
  'nb.admin.limits': 'Sınırlar',
  'nb.admin.timing': 'Zamanlama',
  'nb.admin.vault': 'Şifre Kasam varsayılanları',
  'nb.admin.stats': 'Kullanım',
  'nb.admin.saved': 'Kaydedildi.',
  'nb.admin.m.sheets': 'Çalışma sayfaları',
  'nb.admin.m.collab': 'Canlı ortak düzenleme (imleç, çevrimiçi)',
  'nb.admin.m.comments': 'Yorumlar',
  'nb.admin.m.publicLinks': 'Genel bağlantılar',
  'nb.admin.m.templates': 'Şablonlar',
  'nb.admin.m.imports': 'Dosyadan içe aktarma',
  'nb.admin.m.attachments': 'Ekler ve görseller',
  'nb.admin.m.workspaces': 'Ortak çalışma alanları',
  'nb.admin.m.pushShowTitles': 'Bildirimde not başlığını göster',
  'nb.admin.l.maxNotes': 'Kişi başına not',
  'nb.admin.l.maxFolders': 'Kişi başına klasör',
  'nb.admin.l.maxDocKb': 'Belge boyutu (KB)',
  'nb.admin.l.maxFileMb': 'Ek boyutu (MB)',
  'nb.admin.l.storageMb': 'Kişi başına ek alanı (MB)',
  'nb.admin.l.maxVersions': 'Not başına sürüm',
  'nb.admin.l.trashDays': 'Çöp kutusu (gün)',
  'nb.admin.l.maxShareUsers': 'Not başına paylaşım',
  'nb.admin.l.inviteDays': 'Davet geçerliliği (gün)',
  'nb.admin.l.sheetMaxRows': 'Tablo satırı',
  'nb.admin.l.sheetMaxCols': 'Tablo sütunu',
  'nb.admin.l.importMaxMb': 'İçe aktarma (MB)',
  'nb.admin.l.maxWorkspaceMembers': 'Çalışma alanı üyesi',
  'nb.admin.l.autosaveMs': 'Otomatik kayıt gecikmesi (ms)',
  'nb.admin.l.collabFlushMs': 'Ortak düzenleme gönderim aralığı (ms)',
  'nb.admin.l.autoVersionMinutes': 'Otomatik sürüm aralığı (dk)',
  'nb.admin.l.vaultAutoLockMinutes': 'Otomatik kilit (dk)',
  'nb.admin.l.vaultMinPassphrase': 'En kısa kasa parolası',
  'nb.admin.l.vaultKdfIterations': 'PBKDF2 tur sayısı',
  'nb.admin.l.vaultChangeReminderDays': 'Şifre değiştirme hatırlatması (gün, 0 kapalı)',
  'nb.admin.s.installs': 'Kurulum',
  'nb.admin.s.notes': 'Not',
  'nb.admin.s.shared': 'Paylaşılan not',
  'nb.admin.s.edits7d': 'Son 7 gün düzenleme',
  'nb.admin.s.vaultUsers': 'Kasa kullanan',
  'nb.admin.s.vaultItems': 'Kasa kaydı',
  'nb.admin.s.files': 'Dosya',
} as const;
